import { SITE_LINKS, VK_URL } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { useEulaModal } from "../../providers/EulaModalProvider";

import styles from "./Footer.module.css";

const FOOTER_LINK_KEYS = [
  "download",
  "buy",
  "faq",
  "enterKey",
  "support",
  "vk",
] as const;

const FOOTER_HREFS: Record<(typeof FOOTER_LINK_KEYS)[number], string> = {
  download: SITE_LINKS.download,
  buy: SITE_LINKS.pricing,
  faq: SITE_LINKS.faq,
  enterKey: SITE_LINKS.enterKey,
  support: SITE_LINKS.support,
  vk: VK_URL,
};

export function Footer() {
  const { copy } = useLocale();
  const { openModal } = useEulaModal();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <p className={styles.copy}>© TTRPGPlayer</p>
        <nav className={styles.links} aria-label={copy.footer.aria}>
          {FOOTER_LINK_KEYS.map((key) => (
            <a
              key={key}
              className={styles.link}
              href={FOOTER_HREFS[key]}
              {...(key === "vk"
                ? { target: "_blank", rel: "noopener noreferrer" }
                : undefined)}
            >
              {copy.footer.links[key]}
            </a>
          ))}
          <button
            type="button"
            className={styles.linkButton}
            onClick={openModal}
          >
            {copy.footer.links.eula}
          </button>
        </nav>
      </div>
    </footer>
  );
}
